import React, { Component } from "react";
import { Icon, Button } from "react-materialize";

import CartItem from "./CartItem";
// import FileUtils from "../../utils/FileUtils";
import EventUtils from "../../utils/EventUtils";
import NuxeoClient from "../../clients/NuxeoClient";
import CommonConstants from "../../constants/CommonConstants";
import "./CartSidebar.css";
// import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import InfoIcon from "@material-ui/icons/Info";
import DialogBox from "../dialogeBox/DialogBox";
import ConfigurationManager from "../../configuration/ConfigurationManager";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";

class CartSidebar extends Component {
  constructor(props) {
    super(props);
    let tempDate = new Date();
    let month =
      tempDate.getMonth() + 1 < 10
        ? `0${tempDate.getMonth() + 1}`
        : `${tempDate.getMonth() + 1}`;
    let day =
      tempDate.getDate() < 10 ? `0${tempDate.getDate()}` : tempDate.getDate();
    let actualDate = month + `/` + day + `/${tempDate.getFullYear()}`;
    this.state = {
      items: [],
      cartSize: 0,
      downloading: false,
      dateSelect: false,
      startDate: actualDate,
      endDate: actualDate,
      bulkAssetsReport: false,
      searchTerm: null,
      currentUser: null,
    };
    ConfigurationManager.environment = process.env;
    this._handleItemDelete = this._handleItemDelete.bind(this);
    this._handleClearClick = this._handleClearClick.bind(this);
    this._handleDownloadClick = this._handleDownloadClick.bind(this);
    this._handleDateContinue = this._handleDateContinue.bind(this);
    this._handleDateSelector = this._handleDateSelector.bind(this);
    this._handleSnackMsgClose = this._handleSnackMsgClose.bind(this);
    this._handleClose = this._handleClose.bind(this);
    this._returnDateFormat = this._returnDateFormat.bind(this);
  }

  get items() {
    return this.state.items;
  }

  set items(items) {
    this.setState({ items: Array.from(new Set(items)) }, () => {
      const { items } = this.state;
      let cartSize = 0;

      for (let i = 0; i < items.length; i++) {
        if (items[i].properties["file:content"]) {
          cartSize += parseInt(items[i].properties["file:content"].length);
        }
      }
      const cartItemCount = this.state.items.length;
      EventUtils.raiseEvent(
        "update-cart-item-count",
        { count: cartItemCount },
        this.props
      );

      this.cartSize = cartSize;
    });
  }

  get cartSize() {
    return this.state.cartSize;
  }

  set cartSize(cartSize) {
    this.setState({ cartSize: cartSize });
  }

  get downloading() {
    return this.state.downloading;
  }

  set downloading(downloading) {
    this.setState({ downloading: downloading });
  }

  _handleItemDelete(event) {
    let itemIndex = event.detail.index;
    let newItems = this.items;

    newItems.splice(itemIndex, 1);
    this.items = newItems;

    EventUtils.raiseEvent("item-deleted", { items: newItems }, this.props);
  }

  _handleClearClick(event) {
    this.items = [];
    EventUtils.raiseEvent("item-deleted", { items: [] }, this.props);
  }

  _handleDownloadClick(event) {
    this.downloading = true;
    window.Materialize.toast("Download is in progress...", 2000);

    let filesUids = this.items.map((item) => item.uid);
    NuxeoClient.instance().startBulkDownload(
      "Cart.zip",
      filesUids,
      () => (this.downloading = false)
    );
  }

  _handleDateSelector() {
    if (
      this.state.items.length >
      ConfigurationManager.getProperty("MAX_SELECTION_COUNT")
    ) {
      this.setState({
        bulkAssetsReport: true,
      });
      return;
    }
    this.setState({ dateSelect: true });
  }

  _returnDateFormat(date) {
    let [month, day, year] = date.split("/");
    return `${year}-${month}-${day}`;
  }

  async _handleDateContinue(event) {
    let [month, date, year] = new Date().toLocaleDateString().split("/");

    let startDate = new Date(this.state.startDate);
    let endDate = new Date(this.state.endDate);
    let presentDate = new Date(`${year}-${month}-${date + 1}`);
    if (startDate > presentDate || endDate > presentDate) {
      this.setState({
        openSnackMsg: true,
        snackBarMsg: `Dates cannot be greater than ${year}-${month}-${date}`,
      });
      return;
    }
    if (this.state.startDate === "" || this.state.endDate === "") {
      this.setState({
        openSnackMsg: true,
        snackBarMsg: "Please select the date range",
      });
      return;
    }
    // else if (startDate >= endDate) {
    //   this.setState({
    //     openSnackMsg: true,
    //     snackBarMsg: "End Date should be greater than Start Date",
    //   });
    //   return;
    // }
    else {
      const { items } = this.state;
      let time = new Date().toISOString().split("T")[1];
      EventUtils.raiseEvent(
        "run-report",
        {
          items: items,
          startDate: this._returnDateFormat(this.state.startDate),
          endDate: this._returnDateFormat(this.state.endDate) + `T${time}`,
        },
        this.props
      );
      this.setState({ dateSelect: false });
    }
  }

  // _handleRunReportClick(event) {
  //   const { items } = this.state;
  //   EventUtils.raiseEvent("run-report", { items: items }, this.props);
  // }

  _handleClose(event) {
    this.setState({
      bulkAssetsReport: false,
      dateSelect: false,
    });
  }

  _handleSnackBarMessageDisplay(message) {
    this.setState({
      openSnackMsg: true,
      snackBarMsg: message,
    });
  }

  _handleSnackMsgClose(event) {
    this.setState({ openSnackMsg: false });
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.searchTerm !== null) {
      this.setState({ searchTerm: props.searchTerm });
    }
    if (props.reportInProgress !== this.props.reportInProgress) {
      this.setState({ reportInProgress: props.reportInProgress });
    }
    if (props.currentUser !== null) {
      this.setState({
        currentUserEmail: props.currentUser.properties.email,
      });
    }
  }
  render() {
    // const { items, cartSize, downloading } = this.state;
    const { items } = this.state;
    const { hidden, view } = this.props;

    return (
      <>
        <aside
          className="cart-sidebar"
          style={hidden ? { left: "-320px" } : {}}>
          <div id="container">
            <div className="content">
              <div
                className={
                  view === "assetview"
                    ? "asset-item-list items-list"
                    : "submission-item-list items-list"
                }>
                {items.map((item, index) => {
                  let views = item.properties["picture:views"];
                  let subtitle =
                    item.type === CommonConstants.ARCHIVE_ASSETS_FILE_TYPE
                      ? item.properties["archive_file:archiveSubmissionId"]
                      : item.properties["submission:propertyName"];
                  let thumbnail = views[CommonConstants.FILE_VIEWS_THUMBNAIL]
                    ? views[CommonConstants.FILE_VIEWS_THUMBNAIL].content.data
                    : null;
                  return (
                    <CartItem
                      key={index}
                      id={index}
                      thumbnail={thumbnail}
                      title={item.title}
                      subtitle={subtitle}
                      onDelete={this._handleItemDelete}
                    />
                  );
                })}
              </div>
              {this.state.bulkAssetsReport ? (
                <DialogBox
                  alert={this.state.bulkAssetsReport}
                  totalCount={this.state.items.length}
                  searchTerm={this.state.searchTerm}
                  _handleClose={this._handleClose}
                  _handleSnackBarMessageDisplay={
                    this._handleSnackBarMessageDisplay
                  }
                  currentUserEmail={this.state.currentUserEmail}
                  selectedAssets={this.state.items.map((item) => item.uid)}
                  handleClearClick={this._handleClearClick}
                />
              ) : null}
              {this.state.dateSelect && (
                <Dialog
                  open={this.state.dateSelect}
                  onClose={() => {
                    this.setState({
                      mailMesaage: false,
                      dateSelect: false,
                    });
                  }}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description">
                  <form noValidate onSubmit={() => {}}>
                    <div className="date-container">
                      <div className="date-selector">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            margin="normal"
                            id="start-date-picker-dialog"
                            label="Start Date"
                            format="MM/dd/yyyy"
                            value={this.state.startDate}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                            InputProps={
                              {
                                disableUnderline: true,
                                style: { borderColor: "blue" },
                              } // } //   { shrink: true } // className={classes.textField} // InputLabelProps={
                            }
                            onChange={(event, date) => {
                              // setStartDate(event);
                              this.setState({ startDate: date });
                            }}
                          />
                          <KeyboardDatePicker
                            margin="normal"
                            id="end-date-picker-dialog"
                            label="End Date"
                            format="MM/dd/yyyy"
                            value={this.state.endDate}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                            InputLabelProps={
                              { shrink: true } // className={classes.textField}
                            }
                            InputProps={{
                              disableUnderline: true,
                              style: { borderColor: "blue" },
                            }}
                            onChange={(event, date) => {
                              // setEndDate(event);
                              this.setState({ endDate: date });
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                    </div>
                  </form>
                  <DialogActions>
                    <Button onClick={this._handleClose} className="button">
                      Cancel
                    </Button>
                    <Button
                      onClick={this._handleDateContinue}
                      className="button"
                      autoFocus>
                      Generate Report
                    </Button>
                  </DialogActions>
                </Dialog>
              )}
              <div className="toolbar">
                <div
                  className="actions"
                  style={{ display: items.length > 0 ? "block" : "none" }}>
                  <div className="layout horizontal">
                    <Button
                      disabled={this.props.reportInProgress}
                      waves="light"
                      style={{ fontSize: "10px" }}
                      onClick={this._handleDateSelector}>
                      Run Report
                      <Icon left>bar_chart</Icon>
                    </Button>
                  </div>
                </div>
                <div className="actions">
                  <div className="layout horizontal">
                    <Button
                      waves="light"
                      style={{ fontSize: "10px" }}
                      disabled={items.length === 0}
                      onClick={this._handleClearClick}>
                      Clear
                      <Icon left>remove_shopping_cart</Icon>
                    </Button>
                    {/* <Button
                      waves="light"
                      style={{ fontSize: "10px" }}
                      disabled={items.length === 0 || downloading}
                      onClick={this._handleDownloadClick}>
                      Download
                      <Icon left>file_download</Icon>
                    </Button> */}
                  </div>
                </div>
              </div>
              {/* <label className="cart-size">
                Cart Size: {FileUtils.getHumanReadableSize(cartSize)}
              </label> */}
            </div>
          </div>
        </aside>
        <div className="snack-bar-container">
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={this.state.openSnackMsg}
            onClose={this._handleSnackMsgClose}
            autoHideDuration={6000}
            ContentProps={{ "aria-describedby": "snack-bar-msg" }}
            message={
              <div className="snack-bar-msg-content">
                <span className="snack-bar-msg-icon">
                  <InfoIcon />
                </span>
                <span className="snack-bar-msg">{this.state.snackBarMsg}</span>
              </div>
            }
            action={[
              <IconButton
                key="close"
                aria-label="close"
                color="inherit"
                className="snack-msg-close-icon"
                onClick={this._handleSnackMsgClose}>
                <CloseIcon />
              </IconButton>,
            ]}
          />
        </div>
      </>
    );
  }
}

export default CartSidebar;
